import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMenuApp } from '@/components/feature/MenuApp';
import Logo from './Logo';

interface CabecalhoProps {
  titulo?: string;
  subtitulo?: string;
  voltar?: boolean;
  acao?: ReactNode;
  /** Conteúdo opcional exibido ao lado do título (ex.: o balão de ajuda). */
  aoLadoDoTitulo?: ReactNode;
  claro?: boolean;
  /** Largura máxima da coluna interna (padrão das telas antigas: 1400px). */
  larguraMaxima?: string;
  /** Título maior (28/22px) para as telas "Festa". */
  destaque?: boolean;
}

// Cabeçalho único para todas as telas: logo, voltar, título e ação à direita.
export default function Cabecalho({
  titulo,
  subtitulo,
  voltar = false,
  acao,
  aoLadoDoTitulo,
  claro = false,
  larguraMaxima = 'max-w-[1400px]',
  destaque = false,
}: CabecalhoProps) {
  const navigate = useNavigate();
  const { abrir: abrirMenu } = useMenuApp();
  return (
    <header
      className={`sticky top-0 z-40 border-b backdrop-blur-md ${
        claro ? 'border-white/10 bg-primary-700/90' : 'border-secondary-200/60 bg-white/90'
      }`}
    >
      <div
        className={`mx-auto flex w-full items-center gap-2 px-4 md:px-6 ${destaque ? 'h-14 md:h-[72px]' : 'h-14'} ${larguraMaxima}`}
      >
        {voltar && (
          <button
            type="button"
            onClick={() => navigate(-1)}
            aria-label="Voltar"
            className={`flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full transition-colors ${
              claro ? 'text-white hover:bg-white/10' : 'text-foreground-700 hover:bg-background-100'
            }`}
          >
            <i className="ri-arrow-left-line text-xl" />
          </button>
        )}
        {titulo ? (
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <h1
                className={`min-w-0 flex-1 truncate ${
                  destaque
                    ? 'text-[22px] font-extrabold leading-tight md:text-[28px]'
                    : 'text-base font-bold'
                } ${claro ? 'text-white' : 'text-foreground-950'}`}
              >
                {titulo}
              </h1>
              {aoLadoDoTitulo && <span className="shrink-0">{aoLadoDoTitulo}</span>}
            </div>
            {subtitulo && (
              <p
                className={`truncate ${destaque ? 'text-xs md:text-sm' : 'text-xs'} ${
                  claro ? 'text-white/80' : 'text-foreground-500'
                }`}
              >
                {subtitulo}
              </p>
            )}
          </div>
        ) : (
          <Logo className="flex-1" claro={claro} />
        )}
        {acao && <div className="flex shrink-0 items-center">{acao}</div>}
        <button
          type="button"
          onClick={abrirMenu}
          aria-label="Menu"
          className={`ml-1 flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full md:hidden ${
            claro ? 'text-white hover:bg-white/10' : 'text-foreground-700 hover:bg-background-100'
          }`}
        >
          <i className="ri-menu-line text-[22px]" aria-hidden />
        </button>
      </div>
    </header>
  );
}